/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useCallback } from "react";
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
import FormRenderer from '../Component/Forms/FormRenderer';
import ThemeControls from "../Component/AllThemesControl";
import { Form } from '../Component/Forms/formElement';
import { MasterContext } from '../services/MasterContext';
import { APIPOST, APIPATCH, APIGET, APIUPLOAD } from '../services/APIServices';
import { BiSolidPlusCircle, BiSolidMinusCircle } from "react-icons/bi";
import Dialog from '@mui/material/Dialog';
import Table from './SubTable.js';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation, useParams } from 'react-router-dom';
import GenDealForm from '../Component/Template/SubForm.js'


function TabPanels(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [openTab, setOpenTab] = React.useState(0);
  const { contextJson, contextObjective, apiContextObj, setEditData } = React.useContext(FormJSONCreateContext);
  const [masterJson, setMasterJson] = React.useState(contextJson);
  const [btnLoading, setBtnLoading] = React.useState(false);
  // const [btnName, setBtnName] = React.useState(false);
  let navigate = useNavigate()
  const { id } = useParams();
  function handelnavigate(event, link) {
    event.preventDefault();
    navigate(link)
  }
  async function settingData(apiPath,msg) {
    return await APIGET(apiPath).then(data => {
      try {
        if (data) {
          if(data.statusCode==="Success" && data.data){
            setEditData([data.data])
            setBtnLoading(false)
            props.hendleErrorMsg(msg, 'success')
          }else{
            setBtnLoading(false)
            props.hendleErrorMsg("Server Error: Please try again later.", 'error')
          }
        } else {
          setBtnLoading(false)
          props.hendleErrorMsg("Server Error: Please try again later.", 'error')
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
      }
    })
  }

  function handleRefreshDeal(event) {
    event.preventDefault();
    setBtnLoading(true)
    const msg = "Deal Refresh Complete: Your deal has been refreshed."
    const path = apiContextObj.apiContextDealRefresh + `${id}`;
    settingData(path,msg);
  }

  function handleOverFlowDeal(event) {
    event.preventDefault();
    props.setOpenDeal(true)
  }

  function cardOpen(index) {
    setOpenTab(prevTab => (prevTab === index ? -1 : index));
  }

  const objData = Object.keys(contextJson).map((key, index) => {
    const valiBtn = contextJson[key] && contextJson[key].fields && contextJson[key].fields.some(item => item.field_id === 'status' && item.field_value === 2);

    if (key !== "xioFEConfig" && contextJson[key].display_on_create !== "hide" && contextObjective === 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
            {contextJson[key].btn_name && (
              <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson[key].btn_link)}>
                {contextJson[key].btn_name}
              </button>
            )}
          </div>
          <FormRenderer formJSON={contextJson[key]} />
        </div>
      );
    } else if (key !== "xioFEConfig" && contextObjective !== 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
            <div className={classes.btnsfrm}>
              {contextJson[key].btn_name && (
                <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson[key].btn_link)}>
                  {contextJson[key].btn_name}
                </button>
              )}
              {contextJson[key].btn_name_2 && valiBtn && (
                <button className={classes.subBtn} disabled={btnLoading} onClick={(event) => handleRefreshDeal(event)}>
                  {btnLoading?
                  <div class={classes.loading08}>
                    <span data-text="L">L</span>
                    <span data-text="O">O</span>
                    <span data-text="A">A</span>
                    <span data-text="D">D</span>
                    <span data-text="I">I</span>
                    <span data-text="N">N</span>
                    <span data-text="G">G</span>
                  </div>:contextJson[key].btn_name_2}
                </button>
              )}
              {contextJson[key].btn_name_3 && valiBtn && (
                <button className={classes.subBtn} onClick={(event) => handleOverFlowDeal(event)}>
                  {contextJson[key].btn_name_3}
                </button>
              )}
            </div>
          </div>
          <FormRenderer formJSON={contextJson[key]} />
        </div>
      );
    }
    return null;
  });

  return objData;
}

function TabFormPart(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [postResponse, setPostResponse] = React.useState();
  const [openAlert, setOpenAlert] = React.useState(false);
  const { contextJson, renderSuccessPage } = React.useContext(FormJSONCreateContext);
  const { apiContextObj, editData, setEditData, contextDataArr, contextIndex } = React.useContext(FormJSONCreateContext);
  let { contextObjective } = React.useContext(FormJSONCreateContext);
  const { masterData } = React.useContext(MasterContext);
  const [disableBtn, setDesable] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDeal, setOpenDeal] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [msgtype, setMsgType] = React.useState('error');
  const [btnLoading, setBtnLoading] = React.useState(false);
  // let navigate = useNavigate()
  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const hendleErrorMsg = useCallback((msg, type) => {
    if (msg) {
      setOpen(true);
      setErrorMsg(msg);
      setMsgType(type)
      setBtnLoading(false)
    }
  }, [setOpen, setErrorMsg]);

  function validateThisForm(jsonContext) {
    let return_error = true;
    jsonContext.fields.forEach(field => {
      if (!elementValidation(field)) {
        return_error = false;
         
        return false;
      }
    });
    return return_error;
  }
  function validateFullForm(contextJson) {
    let return_error = true;
    Object.keys(contextJson).forEach((key) => {
      if (key !== "xioFEConfig") {
       contextJson[key].fields.forEach(field => {
            if (!elementValidation(field)) {
              return_error = false;
               
              return false;
            }
          });
      }})
    return return_error;
  }
  function validateThisFormNested(fields) {
    let return_error = true;
    console.log(fields)
    fields.forEach((items) => {
      items.forEach((item) => {
        if (!elementValidation(item)) {
          return_error = false;
          return false;
        }
      });
  });
    return return_error;
  }
  function validateThisFormSubsidy(fields) {
    let sum = 0;
    let return_error = true;
    fields.forEach((items) => {
        items.forEach((item) => {
            if (item && item.field_value_type === "Subsidy") {
                sum += parseFloat(item.field_value);
            }
        });
    });

    if (sum > 100) {
        return_error = false;
        return false;
    }
    return return_error;
}

  function validateThisDealDate(fields) {
    let return_error = false;
    let countryMap = {};
    let brackoutMap = {};
    let techPrefixMap = {};
    let dateMap = {};


    fields.forEach(field => {
      const fieId = field.field_id.split('.')[0]
      if (fieId === 'country') {
        if (countryMap[fieId]) {
          return_error = true;
          console.error(`Duplicate country found: ${field.country}`);
        } else {
          countryMap[fieId] = true;
        }
      }

      if (fieId === 'breakoutname') {
        if (brackoutMap[fieId]) {
          return_error = true;
          console.error(`Duplicate brackout found: ${field.brackout}`);
        } else {
          brackoutMap[fieId] = true;
        }
      }
      if (fieId === 'techprefix') {
        if (techPrefixMap[fieId]) {
          return_error = true;
          console.error(`Duplicate techPrefix found: ${field.techPrefix}`);
        } else {
          techPrefixMap[fieId] = true;
        }
      }
      if (fieId === 'startdate') {
        if (dateMap[fieId]) {
          return_error = true;
          console.error('Duplicate startdate');
        } else {
          dateMap[fieId] = true;
        }
      }
      if (fieId === 'enddate') {
        if (dateMap[fieId]) {
          return_error = true;
          console.error('DUPLICA END DATE');
        } else {
          dateMap[fieId] = true;
        }
      }
    });

    if (return_error) {
      alert("Validation errors found. Please check the console for details.");
    }

    return return_error;
  }

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  // console.log(contextDataArr)

  async function handleSubmit(event) {
    setBtnLoading(true)
    event.preventDefault();
    window.scrollTo(0, 0);
    let isFormValid = true;
    let isFormSubsidy = true;
    let apiSign = '/save'
    const fdata = {};
    let Arry = [];
    const objData  = {};
    let data;

    Object.keys(contextJson).forEach((key,_i) => {
      if (key !== "xioFEConfig") {
        const form = contextJson[key];
        isFormValid = validateFullForm(contextJson)
        if (isFormValid && validateFullForm(contextJson)) {
          form.fields.forEach((thisField) => {
            const { field_type, field_id, field_value, field_keyValue, url, field_data_type } = thisField;

            if (field_type === "qRCode") {
              fdata[field_id] = field_value;
              fdata[field_keyValue] = url;
            } else if (field_type === "dragDropSelect") {
              objData['id']=field_id
              objData['value']=field_value ? field_value : [];
              // Arry = field_value ? field_value : [];
            } else if (field_type === "RateSheetAddRow") {
              data={...field_value}
              // Arry = field_value.split(', ').map(Number);
            } else if (field_type === "nestedRender") {
              Object.keys(thisField.field_context).forEach((key, index) => {
                const data = {}
                const convertInnerArrayToObject = (innerArray) => {
                  const resultObject = {};
                  innerArray.forEach(field => {
                    const { field_id, field_value } = field;
                    const fieldId = field_id.split(".")[0];
                    resultObject[fieldId] = field_value;
                  });
                  return resultObject;
                };
                console.log(field_value)
                if (thisField.field_context[key].TabStyle === "TabFormRow") {
                  isFormValid = validateThisFormNested(field_value)
                  // isFormValid = validatedValues?.[0]
                  console.log(validateThisFormNested(field_value))
                  if (isFormValid) {
                    if (field_data_type === 'Array') {
                      Arry = field_value?.map(item => convertInnerArrayToObject(item));
                      console.log(field_value)
                    } else {
                      // Use map to convert each inner array to an object
                      const arrayOfObjects = field_value.map(innerArray => convertInnerArrayToObject(innerArray));
                      data['data'] = arrayOfObjects
                      fdata[field_id] = data;
                    }
                  }
                } else {
                  if (key !== "xioFEConfig") {
                    const form = thisField.field_context[key];
                    isFormValid = validateThisForm(form)
                    if (isFormValid) {
                      if (key !== "xioFEConfig" && thisField.field_context[key].field_type !== "" && field_data_type !== 'Obj' && field_data_type !== 'Array') {
                        const data = {}
                        const obj = thisField.field_context[key].fields.reduce((accumulator, field) => {
                          accumulator[field.field_id] = field.field_value;
                          return accumulator;
                        }, {});
                         console.log(obj)
                         if (obj.email) {
                           const emailArray = obj.email.split(',').map(email => email.trim());

                           const result = emailArray.map(email => ({
                             notification: obj.notification,
                             email: email.toLowerCase()
                           }));
  
                          console.log(result)
                          data['data'] = [...result];
                        }else if (obj.routebreakout) {
                          const result = obj?.routebreakout.map(route => ({
                            carriertype: obj.carriertype,
                            quality: obj.quality,
                            routecountry: obj.routecountry,
                            routebreakout: route
                          }));
                          console.log(result)
                          data['data'] = [...result];
                        } else {
                          data['data'] = [{ ...obj }];
                        }
                        // data['data'] =[{ ...obj }]
                        fdata[field_id] = data;
                      } else if (key !== "xioFEConfig" && thisField.field_context[key].field_type !== "" && field_data_type === 'Obj') {
                        const obj = thisField.field_context[key].fields.reduce((accumulator, field) => {
                          accumulator[field.field_id] = field.field_value;
                          return accumulator;
                        }, {});
                        // console.log(obj)
                        fdata[field_id] = obj;
                      }
                    }
                  }
                }
              });
            } else if (field_type === "nestedAddRowRender") {
              console.log(field_value)
              if(field_value&&Array.isArray(field_value)){
                isFormSubsidy = validateThisFormSubsidy(field_value)
                isFormValid = validateThisFormNested(field_value)
              }
              const arrayOfObjects = Array.isArray(field_value) && field_value?.map(innerArray => {

                if (isFormValid && isFormSubsidy) {
                  const resultObject = {};
                  innerArray.forEach(field => {
                    const { field_id, field_value, field_temp_bucket } = field;
                    const response = field_temp_bucket != undefined ? field_temp_bucket : [];
                    const fieldId = field_id.split(".")[0];
                    console.log(field_temp_bucket)
                    let field_value_array = [];
                    if (Array.isArray(field_value)) {
                      field_value_array = field_value;
                    } else if (typeof field_value === 'string') {
                      field_value_array = field_value.split(', ');
                    }
                    if (fieldId === 'breakoutname') {
                      // if (field_temp_bucket != undefined && field_value) {

                      //   field_value_array?.forEach(field_item => {
                      //     const existingObject = response.find(obj => obj.breakout === field_item);
                      //     if (existingObject) {
                      //       existingObject.dealbreakoutid = existingObject.dealbreakoutid || null;
                      //       existingObject.dealdetailid = existingObject.dealdetailid || null;
                      //     }
                      //   });
                      // } else {
                      //   field_value_array?.forEach(field_item => {
                      //     response.push({
                      //       "breakout": field_item,
                      //       "dealdetailid": null,
                      //       "dealbreakoutid": null
                      //     });
                      //   });
                      // }

                      function updateAndAddResponse(field_value_array, response) {
                        // Create a map from field_value_array for quick lookup
                        const valueMap = new Map(field_value_array.map(value => [value, true]));
                        
                        // Create a set of breakout values already present in response
                        const existingBreakoutSet = new Set(response.map(item => item.breakout));
                        
                        // Create a map to replace existing breakout in response
                        const updatedResponseMap = new Map();
                        
                        // Iterate through field_value_array and update/replace breakout in response
                        field_value_array.forEach((value, index) => {
                          // If there is an existing item in response to replace
                          if (response[index]) {
                            updatedResponseMap.set(value, {
                              ...response[index],
                              breakout: value
                            });
                          } else {
                            // If response does not have an item to replace, add new entry
                            updatedResponseMap.set(value, {
                              breakout: value,
                              dealdetailid: null, // Or provide a default or generated value
                              dealbreakoutid: null // Or provide a default or generated value
                            });
                          }
                        });
                      
                        // Convert the updated response map to an array
                        const updatedResponseArray = Array.from(updatedResponseMap.values());
                      
                        return updatedResponseArray;
                      }

                      resultObject['gtsDealbreakout'] = updateAndAddResponse(field_value_array, response);
                    }

                    if (fieldId === 'techprefix') {
                      // if (field_temp_bucket != undefined && field_value) {

                      //   field_value_array?.forEach(field_item => {
                      //     const existingObject = response.find(obj => obj.techprefix === field_item);
                      //     if (existingObject) {
                      //       existingObject.dealtechprefixid = existingObject.dealtechprefixid || null;
                      //       existingObject.dealdetailid = existingObject.dealdetailid || null;
                      //     }
                      //   });
                      // } else {
                      //   field_value_array?.forEach(field_item => {
                      //     response.push({
                      //       "techprefix": field_item,
                      //       "dealdetailid": null,
                      //       "dealtechprefixid": null
                      //     });
                      //   });
                      // }
                      function updateAndAddResponse(field_value_array, response) {
                        // Create a map from field_value_array for quick lookup
                        const valueMap = new Map(field_value_array.map(value => [value, true]));
                        
                        // Create a set of techprefix values already present in response
                        const existingTechprefixSet = new Set(response.map(item => item.techprefix));
                        
                        // Create a map to replace existing techprefix in response
                        const updatedResponseMap = new Map();
                        
                        // Iterate through field_value_array and update/replace techprefix in response
                        field_value_array.forEach((value, index) => {
                          // If there is an existing item in response to replace
                          if (response[index]) {
                            updatedResponseMap.set(value, {
                              ...response[index],
                              techprefix: value
                            });
                          } else {
                            // If response does not have an item to replace, add new entry
                            updatedResponseMap.set(value, {
                              techprefix: value,
                              dealdetailid: null, // Or provide a default or generated value
                              dealtechprefixid: null // Or provide a default or generated value
                            });
                          }
                        });
                      
                        // Convert the updated response map to an array
                        const updatedResponseArray = Array.from(updatedResponseMap.values());
                      
                        return updatedResponseArray;
                      }

                      resultObject['gtsDealtechprefix'] = updateAndAddResponse(field_value_array, response);
                    }

                    resultObject[fieldId] = field_value;
                  });
                  return resultObject;
                } 
              });
              console.log(arrayOfObjects)
              fdata[field_id] = arrayOfObjects;
            } else if (field_type === "routingInfo") {
              fdata[field_id] = field_value;
            } else if (field_type === "date") {
              const data_regex_format2 = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
              if (field_value) {
                fdata[field_id] = data_regex_format2.test(field_value) ? field_value : field_value.split('-').reverse().join('-');
              }
            } else if (field_value === "formJsonData") {
              fdata[field_id] = JSON.stringify(field_value);
            } else if (field_type !== "multiSelect" && field_type !== "" && field_type !== "undefined") {
              fdata[field_id] = field_value;
            }
          });
        }else{
          setBtnLoading(false)
          console.log('form error')
        }
      }
    });

    if (apiContextObj?.apiContextSave === "usersRoles" || apiContextObj?.apiContextSave === "gtsReportingteam") {
      const dataArray = objData.value
        .filter(item => !item.disabled)
        .map(item => item.value);
      console.log(fdata)
      const result = dataArray.map((carrierId) => ({ ...fdata, [objData.id]: carrierId }));

      data = [...result];
      apiSign = '/saveAll'
    } else {
      data = { ...fdata };
    }

     
    async function postingData(contextJson) {
      masterData[`${apiContextObj.apiContextSave}`] = {}
      try {
        const response = await APIPOST(apiContextObj.apiContextSave + apiSign, data, contextJson, renderSuccessPage, hendleErrorMsg);
        // setPostResponse(response.data);
        if (response) {
          // setPostResponse(response.data);
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
    async function uploadingData(contextJson) {
      masterData[`${apiContextObj.apiContextSave}`] = {}
      try {
        const response = await APIUPLOAD(apiContextObj.apiContextSave, data, contextJson, renderSuccessPage, hendleErrorMsg);
        if (response) {
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    async function updateData(contextJson) {
      try {
        if (data) {
          if (Array.isArray(data)) {
            const promises = data.map(async (dataItem, i) => {
              const response = await APIPATCH(apiContextObj.apiContextSave + '/' + contextDataArr[contextIndex][apiContextObj.id], dataItem, contextJson, renderSuccessPage, hendleErrorMsg);
              if (response) {
                return response.data;
              }
            });
            const responses = await Promise.all(promises);
            setPostResponse(responses);
            return responses;
          } else if (typeof data === 'object') {
            const response = await APIPATCH(apiContextObj.apiContextSave + '/' + contextDataArr[contextIndex][apiContextObj.id], data, contextJson, renderSuccessPage, hendleErrorMsg);
            if (response) {
              setPostResponse(response.data);
              return response.data;
            }
          }
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    // if (isFormValid) {
    //   if (contextObjective === "create") {
    //     postingData(contextJson);
    //   } else if (contextObjective === "update") {
    //     updateData(contextJson)
    //   }
    // } else{
    //   const msg = 'Please Check Form for errors!';
    //   hendleErrorMsg(msg);
    // }

    if (!isFormValid && !isFormSubsidy) {
      const msg = 'Please Check Form for errors And Your Subsidy% is Greater than 100%';
      hendleErrorMsg(msg, 'error');
      return false;
  } else if (!isFormValid) {
      const msg = 'Please Check Form for errors!';
      hendleErrorMsg(msg, 'error');
      return false;
  } else if (!isFormSubsidy) {
      const msg = 'Your Subsidy% is Greater than 100%';
      hendleErrorMsg(msg, 'error');
      return false;
  } else {
      if (contextObjective === "create") {
          postingData(contextJson);
      } else if (contextObjective === "update") {
          updateData(contextJson);
      } else if (contextObjective === "upload") {
        uploadingData(contextJson);
      }
  }
  
    return false;
  }


  let fieldsData = {}
  Object.keys(contextJson).forEach((key, index) => {
    if (key !== "xioFEConfig") {
      fieldsData = contextJson[key].fields.map((field, index) => ({
        key: `${index + 1}`,
        title: field.field_label,
        dataIndex: field.field_id,
      }));
    }
  });

  return (
    <>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={msgtype} sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog
        // open='true'
        open={openAlert}
        // maxWidth='lg'
        onClose={handleCloseAlert}
      >
        <Table fieldsData={fieldsData} contextJson={contextJson} apiContextObj={apiContextObj} id="" />
      </Dialog>
      <Dialog
        // open='true'
        open={openDeal}
        maxWidth='sm'
        className={classes.poup}
        onClose={handleCloseAlert}
      >
        <GenDealForm apiContextObj={apiContextObj} close={setOpenDeal} setEditData={setEditData} />
      </Dialog>
      <TabPanels setOpenDeal={setOpenDeal} hendleErrorMsg={hendleErrorMsg}/>
      <div className={classes.fromBtn}>
        {contextObjective === "save" ? <button className="smtbtn" onClick={handleClickOpen}>Save</button> :
          <button className="smtbtn" type="submit" onClick={handleSubmit} disabled={btnLoading}>
            {btnLoading?
                  <div class={classes.loading08}>
                    <span data-text="L">L</span>
                    <span data-text="O">O</span>
                    <span data-text="A">A</span>
                    <span data-text="D">D</span>
                    <span data-text="I">I</span>
                    <span data-text="N">N</span>
                    <span data-text="G">G</span>
                  </div>:"Submit"}
            </button>
        }
      </div>
    </>
  );
}

export default TabFormPart;
